import dayjs from "dayjs";

const formatDateRange = function (start, end) {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  const today = dayjs();
  const tomorrow = dayjs().add(1, "day");

  // 检查是否为同一天
  if (startDate.isSame(endDate, "day")) {
    if (startDate.isSame(today, "day")) {
      return `${startDate.format("MM.DD HH:mm")}-${endDate.format("HH:mm")}`;
    } else if (startDate.isSame(tomorrow, "day")) {
      return `${startDate.format("MM.DD HH:mm")}-${endDate.format("HH:mm")}`;
    } else {
      return `${startDate.format("YYYY.MM.DD")} ${startDate.format(
        "HH:mm"
      )}-${endDate.format("HH:mm")}`;
    }
  } else {
    // 跨天的情况
    return `${startDate.format("MM.DD HH:mm")}-${endDate.format(
      "MM.DD HH:mm"
    )}`;
  }
};
const formatDistance = function (meters) {
  if (meters < 1000) {
    return `${meters}米`;
  }
  return `${(meters / 1000).toFixed(0)}km`; // 保留1位小数
};
const formatDistanceNoUnit = function (meters) {
  return `${(meters / 1000).toFixed(0)}`; // 保留1位小数
};

const formatDuration = function (seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours > 0) {
    return `${hours}小时${minutes}分钟`;
  }
  return `${minutes}分钟`;
};
export default {
  fd: formatDateRange,
  formatDistance: formatDistance,
  formatDistanceNoUnit: formatDistanceNoUnit,
  formatDuration: formatDuration,
};
